"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var withClickOutside = function withClickOutside(callback) {
  return function (ComposedComponent) {
    return /*#__PURE__*/function (_Component) {
      (0, _inheritsLoose2.default)(Wrapper, _Component);
      function Wrapper() {
        var _this;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.ref = null;
        _this.handleClick = function (event) {
          if (!_this.ref.contains(event.target)) {
            callback(_this.props);
          }
        };
        _this.handleRef = function (ref) {
          _this.ref = ref;
        };
        return _this;
      }
      var _proto = Wrapper.prototype;
      _proto.componentDidMount = function componentDidMount() {
        window.addEventListener('click', this.handleClick);
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('click', this.handleClick);
      };
      _proto.render = function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          ref: this.handleRef
        }, /*#__PURE__*/_react.default.createElement(ComposedComponent, this.props));
      };
      return Wrapper;
    }(_react.Component);
  };
};
var _default = exports.default = withClickOutside;